import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "light",
  user: null,
  users: {
    data: [],
    total: 0,
  },
  roles: [],
  token: null,
  organisation: null,
  organisations: {
    data: [],
    total: 0,
  },
  organisationSearchResults: [],
  snackbar: {
    open: false,
    message: "",
    severity: "error",
  },
  product: null,
  products: { data: [], total: 0 },
  productVersion: null,
  productVersions: [],
  ingredient: null,
  ingredients: [],
  ingredientSearchResults: [],
  emissionRecord: null,
  emissionRecords: { data: [], total: 0 },
  emissionRecordSearchResults: [],
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUsers: (state, action) => {
      state.users = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
    },
    setLogout: (state) => {
      return initialState;
    },
    setRoles: (state, action) => {
      state.roles = action.payload;
    },
    setOrganisation: (state, action) => {
      state.organisation = action.payload;
    },
    setOrganisations: (state, action) => {
      state.organisations = action.payload;
    },
    setOrganisationSearchResults: (state, action) => {
      state.organisationSearchResults = action.payload;
    },
    setSnackbar: (state, action) => {
      state.snackbar = action.payload;
    },
    setProduct: (state, action) => {
      state.product = action.payload;
    },
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setProductVersion: (state, action) => {
      state.productVersion = action.payload;
    },
    setProductVersions: (state, action) => {
      state.productVersions = action.payload;
    },
    setIngredient: (state, action) => {
      state.ingredient = action.payload;
    },
    setIngredients: (state, action) => {
      state.ingredients = action.payload;
    },
    setIngredientSearchResults: (state, action) => {
      state.ingredientSearchResults = action.payload;
    },
    setEmissionRecord: (state, action) => {
      state.emissionRecord = action.payload;
    },
    setEmissionRecords: (state, action) => {
      state.emissionRecords = action.payload;
    },
    setEmissionRecordSearchResults: (state, action) => {
      state.emissionRecordSearchResults = action.payload;
    },
  },
});

export const {
  setMode,
  setUser,
  setUsers,
  setToken,
  setLogin,
  setLogout,
  setRoles,
  setOrganisation,
  setOrganisations,
  setSnackbar,
  setOrganisationSearchResults,
  setProduct,
  setProducts,
  setProductVersion,
  setProductVersions,
  setIngredient,
  setIngredients,
  setIngredientSearchResults,
  setEmissionRecord,
  setEmissionRecords,
  setEmissionRecordSearchResults,
} = authSlice.actions;

export default authSlice.reducer;
